import styled from "styled-components"



export const FoodDetailsContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const FoodDetailsBody = styled.div`
  overflow-y: auto;
  height: calc(100% - var(--app-cta-height));
`

export const FoodDetailsInfo = styled.div`
  padding: 16px var(--app-horizontal-padding);
  gap: 12px;
  display: flex;
  flex-direction: column;
  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`


